<template>
  <div class="navtool gap-3">
    <tool :nt="false" title="Previous" class="navt v-left" @click="$bus.$emit('prev')">
      <template v-slot="{ hover }">
        <icon :coloured="hover === true" name="Arrow" class="icon"/>
      </template>
    </tool>
    <tool :nt="false" title="Next" class="navt v-right" @click="$bus.$emit('next')">
      <template v-slot="{ hover }">
        <icon :coloured="hover === true" name="Arrow" class="icon transform -rotate-180"/>
      </template>
    </tool>
  </div>
</template>

<script>
import Tool from '@components/tools/Tool';

export default {
  name: 'NavTool',
  components: { Tool },
};
</script>

<style scoped lang="scss">
.navtool {
  display: flex;
  flex-direction: row !important;

  .navt {
    position: relative !important;

    &.v-left {
      margin-right: 0.25rem;
      align-items: flex-end;
    }

    &.v-right {
      margin-left: 0.25rem;
      align-items: flex-start;
    }
  }
}
</style>
